import ProductList from '@/components/Product/ProductList'
import ProductFavoritesList from '@/components/Product/ProductFavoritesList'
import ProductDetail from '@/components/Product/ProductDetail'
import AdminProductList from '@/components/Product/AdminProductList'
import AdminProductForm from '@/components/Product/AdminProductForm'
import AdminProductDetail from '@/components/Product/AdminProductDetail'

let ProductRouter = [
    {
        path: '/admin/product',
        name: 'AdminProductList',
        component: AdminProductList,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin/product/new',
        name: 'AdminProductNew',
        component: AdminProductForm,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin/product/:id/edit',
        name: 'AdminProductEdit',
        component: AdminProductForm,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin/product/:id',
        name: 'AdminProductDetail',
        component: AdminProductDetail,
        meta: {
            requiresAuth: true
        }
    },
{
    path: '/product/category/:cat',
    name: 'ProductListCat',
    component: ProductList
}, {
    path: '/product/',
    name: 'ProductList',
    component: ProductList
},{
    path: '/product/favorites',
    name: 'ProductFavoritesList',
    component: ProductFavoritesList
}, {
  path: '/product/:id',
  name: 'ProductDetail',
  component: ProductDetail,
}]

export default ProductRouter



// WEBPACK FOOTER //
// ./src/components/Product/router.js